export async function request(method: string, authToken: string | null, endpoint: string) {
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    if (localStorage.tokenExpirationInMinutes) {
        console.warn(
            'requesting token with non standard expiration duation',
            localStorage.tokenExpirationInMinutes,
            'minutes'
        );
        headers.append(
            'Hoylu-test-token-lifetime-minutes',
            localStorage.tokenExpirationInMinutes
        );
    }
    if (authToken) {
        headers.append('Authorization', `Bearer ${authToken}`);
    }
    const response = await fetch(
        new Request(endpoint, {
            method: method,
            headers,
            mode: 'cors'
        })
    );

    if (response.status >= 300) {
        throw Error(await response.text());
    }
    return response;
}
